exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.edit-local-business__loading,.edit-local-business__section{margin-top:28px}.edit-local-business__header h3{display:flex;align-items:center}.edit-local-business__header h3 svg{margin-right:8px}.edit-local-business .country-selector{position:relative;height:48px}.edit-local-business .row--data{margin-bottom:4px;font-size:14px}.edit-local-business .row--action{margin-top:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/plus/editLocalBusiness.scss
// module id = 901
// module chunks = 0